import axiosInstance from "./authentication/axiosInstance";

export const userServices = {
  getUsersByRoleName: async () => {
    const response = await axiosInstance.get("/users/usersforJobStatus");
    return response.data;
  },

  getOwnerUsersByTeamScreen: async () => {
    const response = await axiosInstance.get("/users/usersRoleJobForTeam");
    return response.data;
  },

  getUserForTaskScreen: async () => {
    const response = await axiosInstance.get("/users/usersforTaskScreen");
    return response.data;
  },

  getUserDetails: async (userEmail) => {
    const response = await axiosInstance.get(`/users/usersDetailsById/${userEmail}`);
    return response.data;
  },

  getUserDetailsWithoutStore: async (userEmail) => {
    const response = await axiosInstance.get(`/users/usersDetailsById/${userEmail}`);
    return response.data;
  },

  getAllUser: async (search, filter, page, size, sortField, sortDir) => {
    const params = new URLSearchParams({
      search: search || '',
      filter: filter || '',
      pageNo: page,
      size: size,
      sortField: sortField || 'id',
      sortDir: sortDir || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/users/allUser?${params}`);
    return response.data;
  },

  getAllLoggedOutUsers: async () => {
    const response = await axiosInstance.get("/users/loggedOutUsers");
    return response.data;
  },

  updateUserData: async (updateFormData) => {
    const response = await axiosInstance.patch("/users/updateUser", updateFormData);
    return response.data;
  },

  deleteUserData: async (userId) => {
    const response = await axiosInstance.delete(`/users/${userId}`);
    return response.data;
  },

  resetPasswordById: async (formData) => {
    const response = await axiosInstance.post(`/users/resetPassword`, formData);
    return response.data;
  },

  getMemberUserForTeam: async () => {
    const response = await axiosInstance.get("/users/usersRoleTaskForTeam");
    return response.data;
  },

  getTeamMembersData: async (teamId) => {
    const response = await axiosInstance.get(`/users/allTeamMembers?teamId=${teamId}`);
    return response.data;
  },

  removeTeamMembersFromTeam: async (userId) => {
    const response = await axiosInstance.delete(`/users/teamMember/${userId}`);
    return response.data;
  },

  getAllUsersWhichHasNoAdminRole: async () => {
    const response = await axiosInstance.get("/users/allUsersCommon");
    return response.data;
  }

};
